import { Action } from '@reduxjs/toolkit';

import type { ReduxAction } from 'app/redux/types';

import { API, getAsyncThunk } from 'app/api';
import type { BackendEntities } from 'app/lib/betting/betting-entities';
import { addBetFactory } from 'app/modules/BetSlip/actions/addBetFactory';

import { matches, objects, sports } from './selectors';

export const RESET_SEARCHED_VALUE = 'SEARCH_PAGE:RESET_SEARCHED_VALUE';

export type FetchSearchedValueRequest = Action<typeof fetchSearchedValue.pending.type>;
export type FetchSearchedValueSuccess = ReduxAction<
  typeof fetchSearchedValue.fulfilled.type,
  BackendEntities
>;
export type FetchSearchedValueFailure = Action<typeof fetchSearchedValue.rejected.type>;

export const fetchSearchedValue = getAsyncThunk(
  'SEARCH_PAGE:FETCH_SEARCHED_VALUE',
  API.search.getSearchedValue,
);

export type ResetSearchedValueActionType = Action<typeof RESET_SEARCHED_VALUE>;

export const resetSearchedValue = (): ResetSearchedValueActionType => ({
  type: RESET_SEARCHED_VALUE,
});

export const addBet = addBetFactory(matches, sports, objects);
